import { FormFieldsMap } from 'UI/components/organisms/CandidateForm/fields';
import { Endpoints } from 'UI/constants/endpoints';

export const DRAFT_REQUIRED_FIELDS = [
  FormFieldsMap.FirstName.key,
  FormFieldsMap.LastName.key,
  FormFieldsMap.Email.key
];

export const CANDIDATE_SOURCES = Object.freeze({
  default: null,
  hiringAuthorityProfile: 'hiringAuthorityProfile',
  contactProfile: 'contactProfile',
  resumeParser: 'resumeParser',
  talentPool: 'talentPool'
});

export const CANDIDATE_DRAFTS_PROVIDERS = {
  talentPool: {
    id: CANDIDATE_SOURCES.talentPool,
    apiEndpoint: Endpoints.CandidateDataFromApplicant
  },
  resumeParser: {
    id: CANDIDATE_SOURCES.resumeParser,
    apiEndpoint: Endpoints.CandidateDataFromResumeParser
  }
};
